<div class="modal-body">
  <button
    (click)="alsWeggeklicktMarkieren()"
    aria-label="schließen"
    class="close p-2 btn ms-auto"
    type="button"
  >
    <h3 aria-hidden="true">&times;</h3>
  </button>
  <h5 class="p-3 text-center header-colour mb-0">
    {{ title }}
  </h5>
  <div [innerHTML]="content" class="ps-5 mb-0"></div>
  <p class="p-3 text-center">
    <span (click)="schliessen(bestaetigen)" class="btn btn-primary float-end"
    >Ok, verstanden!</span
    >
  </p>
</div>
